module.exports = __webpack_public_path__ + "static/img/fuminAgreement.8e0e66a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/account/fuminAgreement.png
// module id = dgQ4
// module chunks = 69